import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useServices } from 'index';

export type ResendInvitesResult = {
  succeeded: number;
  failed: number;
  total: number;
};

export const useResendInvites = (organizationId: string) => {
  const invitesService = useServices().inviteStudentsService;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (inviteIds: string[]): Promise<ResendInvitesResult> => {
      const results = await Promise.allSettled(inviteIds.map((id) => invitesService.resendInvitation(id, organizationId)));
      return {
        succeeded: results.filter((r) => r.status === 'fulfilled').length,
        failed: results.filter((r) => r.status === 'rejected').length,
        total: inviteIds.length,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationInvites', organizationId] });
    },
  });
};
